/* eslint-disable no-use-before-define */
import { Unpublished } from '@mui/icons-material';
import moment from 'moment-timezone';
import { useEffect, useState } from 'react';

const UseCountdown = (targetDate, isRuuning = false, isUnPublished) => {
  let countDownDate = new Date(targetDate).getTime();

  const [countDown, setCountDown] = useState(
    new Date(targetDate).getTime() -
      new Date(
        new Date().toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
      ).getTime()
  );

  useEffect(() => {
    countDownDate = new Date(targetDate).getTime();
    setCountDown(
      new Date(targetDate).getTime() -
        new Date(
          new Date().toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
        ).getTime()
    );
  }, [targetDate]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (isRuuning) {
      const interval = setInterval(() => {
        if (isUnPublished) {
          if (
            countDownDate >=
            new Date(
              new Date().toLocaleString('en-US', {
                timeZone: 'Australia/Sydney',
              })
            ).getTime()
          ) {
            setCountDown(
              countDownDate -
                new Date(
                  new Date().toLocaleString('en-US', {
                    timeZone: 'Australia/Sydney',
                  })
                ).getTime()
            );
          }
        } else {
          if (countDownDate >= new Date().getTime()) {
            setCountDown(
              countDownDate -
                new Date(
                  new Date().toLocaleString('en-US', {
                    timeZone: 'Australia/Sydney',
                  })
                ).getTime()
            );
          }
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [countDownDate]);
  return getReturnValues(
    new Date(targetDate).getTime() -
      new Date(
        new Date().toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
      ).getTime()
  );
};

const getReturnValues = (countDown) => {
  // calculate time left
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return [days, hours, minutes, seconds, countDown];
};

export { UseCountdown };
